<div class="container" style="height: 80vh">
  <div class="toolbar">
    <div style="display: flex; align-items: center; justify-content: space-between">
      <phito-toggle
        componentUniqueId="notification-overview-only-unread"
        label="Nur ungelesene anzeigen"
        (changed)="filterUnread($event)"
        style="padding-left: 6px"
      ></phito-toggle>
      <button
        (click)="markAllAsRead()"
        [disabled]="allRead()"
        color="accent"
        mat-icon-button
        matTooltip="Alle als gelesen markieren"
        >
        <mat-icon>done_all</mat-icon>
      </button>
    </div>
    <div style="display: flex; align-items: center; justify-content: center">
      <mat-form-field class="mat-form-field-no-padding-margin" style="width: 95%">
        <mat-label>Suche</mat-label>
        <input [formControl]="searchCtrl" matInput placeholder="Suche" />
      </mat-form-field>
    </div>
  </div>

  @if (notifications.length === 0 && !onlyUnreadNotifications) {
    <div
      style="color: #777; display: flex; align-items: center; justify-content: center; width: 100%; height: 75vh"
      >
      <mat-hint> Keine Benachrichtigungen</mat-hint>
    </div>
  }

  @if (notifications.length === 0 && onlyUnreadNotifications) {
    <div
      style="color: #777; display: flex; align-items: center; justify-content: center; width: 100%; height: 25vh"
      >
      <mat-hint> Keine ungelesenen Benachrichtigungen</mat-hint>
    </div>
  }

  @if (notifications.length > 0) {
    <div>
      <mat-list style="height: 65vh; overflow-y: auto"
        ><!--[infiniteScrollDistance]="2"
        [infiniteScrollThrottle]="100"
        [infiniteScrollUpDistance]="1.5" [scrollWindow]="false"-->
        @for (notification of notifications; track notification) {
          <div
            (click)="markAsRead(notification)"
            class="notification-item"
            >
            <div style="width: 70px; display: flex; align-items: center; justify-content: center">
              <span class="spacer"></span>
              <div
                        style="
                            width: 10px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            align-self: start;
                            margin-top: 20px;
                        "
                >
                @if (!notification.read) {
                  <div class="unread-dot"></div>
                }
              </div>
              <span class="spacer"></span>
              <div
                [matTooltip]="notification.createdBy?.firstName + ' ' + notification.createdBy?.lastName"
                class="acronym-icon"
                >
                <span>{{ getAcronym(notification) }}</span>
              </div>
              <span class="spacer"></span>
            </div>
            <div style="width: calc(100% - 70px)">
              <div class="one-row">
                <h3 class="item-headline"
                  >{{ notification.createdBy?.firstName }}&nbsp;{{ notification.createdBy?.lastName }}</h3
                  >
                  <span class="spacer"></span>
                  <div
                    [matTooltip]="getDateString(notification)"
                    style="width: 100%; text-align: right; color: #777; font-size: 0.8em; padding-right: 4px"
                    >
                    {{ formatDate(notification.createdAt) }}
                  </div>
                </div>
                <div
                  ><strong>{{ notification.notificationTitle }}</strong></div
                  >
                  <div>{{ notification.notificationText }}</div>
                  <!--          <mat-expansion-panel *ngIf="notification.notificationDetails.length > 0">-->
                  <!--            <mat-expansion-panel-header>-->
                  <!--              <mat-panel-title>mehr...</mat-panel-title>-->
                <!--            </mat-expansion-panel-header>-->
                <!--            <div *ngFor="let detail of notification.notificationDetails">-->
                <!--              {{ detail }}-->
              <!--            </div>-->
            <!--          </mat-expansion-panel>-->
          </div>
        </div>
      }
    </mat-list>
  </div>
}
</div>
